import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ViewSignal } from '../../signal';

@Component({
    selector: 'app-page',
    imports: [RouterOutlet],
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss']
})
export class PageComponent {
    viewSignal = inject(ViewSignal);
    name = computed(() => this.viewSignal.path());
}
